import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Button } from './ui/button';

type UserAvatarButtonContentProps = {
  buttonText: string;
  avatarSrc?: string;
  avatarFallback: string;
  className?: string;
};

export default function UserAvatarButtonContent({
  buttonText,
  avatarSrc,
  avatarFallback,
  className,
}: UserAvatarButtonContentProps) {
  return (
    <>
      <Avatar className="h-8 w-8">
        <AvatarImage src={avatarSrc} />
        <AvatarFallback className="border border-primary-200 bg-primary-100 text-primary-dark">
          {avatarFallback}
        </AvatarFallback>
      </Avatar>
      <span className="text-sm text-gray-800 md:block ">{buttonText}</span>
      <ChevronDownIcon className="h-4 w-4 text-gray-800" />
    </>
  );
}
